function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import buildResponse from "../buildResponse";
import Headers from "../headers/headers";
export default function fullFetch(url, options, fetchFunction, fetchFormat, fetchLog) {
    return new Promise((resolve)=>{
        _async_to_generator(function*() {
            const start = Date.now();
            const { expectedErrors, mutedErrors, timeout, retry, signal } = options, fetchOptions = _object_without_properties(options, [
                "expectedErrors",
                "mutedErrors",
                "timeout",
                "retry",
                "signal"
            ]);
            let abortController = null;
            let timeoutId = null;
            // If the main signal controller is aborted, abort also the current request.
            signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function abortListener() {
                resolve(null);
                abortController === null || abortController === void 0 ? void 0 : abortController.abort();
                abortController = null;
                signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortListener);
            });
            let i = 0;
            /* eslint-disable no-await-in-loop, no-loop-func */ do {
                var _result_error;
                abortController = new AbortController();
                const promiseData = _async_to_generator(function*() {
                    try {
                        const res = yield fetchFunction(url, _object_spread_props(_object_spread({}, fetchOptions), {
                            signal: abortController.signal
                        }));
                        const data = yield res[fetchFormat]();
                        if (!res.ok) {
                            fetchLog(res, Date.now() - start, {
                                expectedErrors,
                                mutedErrors
                            });
                        }
                        return {
                            called: true,
                            loading: false,
                            error: undefined,
                            status: res.status,
                            headers: new Headers(res.headers),
                            data
                        };
                    } catch (err) {
                        const error = err instanceof Error ? err : new Error(`${err}`);
                        const networkErrorRes = buildResponse('', {
                            status: -1,
                            statusText: error.message,
                            url
                        });
                        fetchLog(networkErrorRes, Date.now() - start, {
                            expectedErrors,
                            mutedErrors
                        });
                        return {
                            called: true,
                            loading: false,
                            error,
                            status: undefined,
                            headers: undefined,
                            data: undefined
                        };
                    } finally{
                        if (timeoutId) {
                            clearTimeout(timeoutId);
                            timeoutId = null;
                        }
                    }
                })();
                const promiseTimeout = _async_to_generator(function*() {
                    const err = new Error(`Fetch exceeded timeout of ${timeout} ms`);
                    yield new Promise((res)=>{
                        timeoutId = setTimeout(res, timeout || 2147483647);
                    });
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                        timeoutId = null;
                    }
                    abortController === null || abortController === void 0 ? void 0 : abortController.abort();
                    const networkErrorRes = buildResponse('', {
                        status: -1,
                        statusText: err.message,
                        url
                    });
                    fetchLog(networkErrorRes, Date.now() - start, {
                        expectedErrors,
                        mutedErrors
                    });
                    return {
                        called: true,
                        loading: false,
                        error: err,
                        status: undefined,
                        headers: undefined,
                        data: undefined
                    };
                })();
                const result = yield Promise.race([
                    promiseData,
                    promiseTimeout
                ]);
                // If there's been an abort error, return null to signal the abortion.
                if (((_result_error = result.error) === null || _result_error === void 0 ? void 0 : _result_error.name) === 'AbortError') {
                    return null;
                }
                // If we do not want to retry, return the result.
                if (!(yield retry === null || retry === void 0 ? void 0 : retry(result, i))) {
                    return result;
                }
                i++;
            }while (true)
        /* eslint-enable */ })().then(resolve);
    });
}

//# sourceMappingURL=fullFetch.js.map